import React, { Fragment, useEffect, useState } from "react";
import { LI, P, UL } from "../../../AbstractElements";
import { LogOut } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../../Modules/Auth/Api/Login";

const LogoutClass = () => {
  const Navigate = useNavigate();
  const authenticated = JSON.parse(localStorage.getItem("authenticated"));

  const auth0_profile = JSON.parse(localStorage.getItem("auth0_profile"));

  const [name, setName] = useState("");

  useEffect(() => {
    setName(auth0_profile?.first_name || "Usuario");
  }, [setName]);

  const Logout = () => {
    logout();
  };

  return (
    <Fragment>
      <LI attrLI={{ className: "profile-nav onhover-dropdown p-0" }}>
        <div className="d-flex profile-media">
          <div className="flex-grow-1">
            <span>
              {" "}
              {authenticated ? auth0_profile?.first_name : name}{" "}
              {authenticated ? auth0_profile?.last_name : name}
            </span>
            <P attrPara={{ className: "mb-0 font-roboto" }}>
              Admin
              <i className="middle fa fa-angle-down"></i>
            </P>
          </div>
        </div>
        <UL attrUL={{ className: "profile-dropdown onhover-show-div" }}>
          <LI attrLI={{ onClick: Logout }}>
            <Link to={`${process.env.PUBLIC_URL}/login`}>
              <LogOut />
              Salir
            </Link>
          </LI>
        </UL>
      </LI>
    </Fragment>
  );
};

export default LogoutClass;
